import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import { FullscreenProvider } from './contexts/FullscreenContext';
import LoginPage from './pages/LoginPage';
import DashboardLayout from './components/Layout/DashboardLayout';
import DashboardWrapper from './pages/DashboardWrapper';
// Removed Products and Orders imports
import Analytics from './pages/AnalyticsPage';
import Users from './pages/UsersPage';
import './App.css';

function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <div className="App">
      <FullscreenProvider>
        <Router>
          <Routes>
            <Route 
              path="/login" 
              element={!isAuthenticated ? <LoginPage /> : <Navigate to="/" />} 
            />
            <Route 
              path="/*" 
              element={
                isAuthenticated ? (
                  <Routes>
                    <Route path="/" element={<DashboardWrapper />} />
                    <Route path="/dashboard" element={<DashboardWrapper />} />

                    <Route path="/analytics" element={<DashboardLayout><Analytics /></DashboardLayout>} />
                    <Route path="/users" element={<DashboardLayout><Users /></DashboardLayout>} />
                    <Route path="*" element={<Navigate to="/" />} />
                  </Routes>
                ) : (
                  <Navigate to="/login" />
                )
              } 
            />
          </Routes>
        </Router>
      </FullscreenProvider>
    </div>
  );
}

export default App;